<template>
  <div>
    <b-row
      v-if="
        sliderValue &&
          sliderValue.length > 0 &&
          sliderValue[0] != null &&
          sliderValue[1] != null &&
          sliderValue[0] > 0 &&
          sliderValue[1] > 0
      "
    >
      <b-col cols="4">
        <div class="float-left">
          <div class="filterText">Filter by Year:--stack</div>
        </div>
      </b-col>
      <b-col cols="8">
        <div>
          <b class="mr-3">{{ sliderValue[0] }}</b>
          <b-form-slider
            ref="mySlider"
            v-b-tooltip.hover
            :title="`${sliderValue[0]} - ${sliderValue[1]}`"
            :value="sliderValue"
            v-model="sliderValue"
            :min="min"
            :max="max"
            :range="range"
            @slide-stop="slideChange"
          >
          </b-form-slider>
          <b class="ml-3">{{ sliderValue[1] }}</b>
        </div>
      </b-col>
    </b-row>
    <b-row class="m-0 chartTabPanel autoCursor">
      <b-col ref="capture">
        <Plotly
          v-if="loaded"
          :layout="layout"
          :data="chartData"
          :display-mode-bar="false"
          :xAxisType="xAxisType"
          :yAxisType="yAxisType"
          :margin="margin"
          :title="chartTitle"
          :name="name"
          :width="setChartWidth"
          :heigt="chartHeight"
          :chartBarMode="chartBarMode"
          :tickFormat="tickFormat"
          :tickFormatYaxis2="tickFormatYaxis2"
          :yAxisTitle="yAxisTitle"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";

export default {
  name: "PlotlyMultiBarLineChart",
  props: {
    dataSet: {
      default: [],
    },
    xField: {
      default: "xField",
    },
    yField: {
      default: "yField",
    },
    name: {
      default: "",
    },
    margin: {
      default: {
        l: 80,
        r: 80,
        b: 0,
        t: 0,
        pad: 2,
      },
    },
    chartTitle: {
      default: "",
    },
    yAxisType: {
      default: "linear",
    },
    xAxisType: {
      default: "ordinal",
    },
    chartWidth: { default: "100%" },
    chartHeight: { default: "100%" },
    chartBarMode: { default: "stack" },
    tickFormat: { default: "" },
    tickFormatYaxis2: { default: "" },
    yAxisTitle: { default: "" },
    range: { default: true },
  },

  components: {
    Plotly,
    bFormSlider,
  },
  watch: {
    chartBarMode() {
      this.createChart();
    },
  },
  data() {
    return {
      loaded: true,
      layout: {},
      chartData: [],
      setChartWidth: this.chartWidth,
      postDataCopy: JSON.stringify(this.dataSet),
      min: "",
      max: "",
      sliderValue: [],
    };
  },
  created() {
    // console.log("this.dataSet[0].year", this.dataSet, this.dataSet[0].year);
    if (this.dataSet[0].year.length) {
      this.min = Math.min.apply(Math, this.dataSet[0].year);
      this.max = Math.max.apply(Math, this.dataSet[0].year);
      this.sliderValue = [this.min, this.max];
    }
  },
  mounted() {
    this.$root.$on("createChart");
    this.createChart();
  },
  methods: {
    slideChange(e) {
      var newChartData = JSON.parse(this.postDataCopy);
      let filterData = [];
      if (newChartData && newChartData.length) {
        for (let j = 0; j < newChartData.length; j++) {
          let newData = newChartData[j];
          filterData.push({ x: [], y: [] });
          if (newData.x.length) {
            for (let i = 0; i < newData.x.length; i++) {
              if (
                newData.year &&
                newData.year[i] &&
                parseInt(newData.year[i]) >= parseInt(e[0]) &&
                parseInt(newData.year[i]) <= parseInt(e[1])
              ) {
                filterData[j].x.push(newData.x[i]);
                filterData[j].y.push(newData.y[i]);
              }
            }
          }

          //  console.log('new dataset-==',this.dataSet);
          this.dataSet[j].x = filterData[j].x;
          this.dataSet[j].y = filterData[j].y;
        }

        this.chartData.upperRange = e[1];
        this.chartData.lowerRange = e[0];

        this.sliderValue[0] = e[0];
        this.sliderValue[1] = e[1];
      }
    },
    createChart() {
      this.chartData = this.dataSet;
      if (this.chartData && this.chartData.length) {
        for (let i = 0; i < this.chartData.length; i++) {
          if (Object.keys(this.chartData[i]).includes("year")) {
            this.max = Math.max.apply(Math, this.chartData[i].year);
            this.min = Math.min.apply(Math, this.chartData[i].year);
            this.sliderValue = [this.min, this.max];
            break;
          }
        }
      }
      //-------------Chart Layout-------------
      this.setChartWidth = this.$refs.capture.clientWidth - 50;
      this.layout = {
        title: this.chartTitle,
        margin: this.margin,
        width: this.setChartWidth,
        height: this.chartHeight,
        barmode: this.chartBarMode,
        xaxis: {
          autorange: true,
          nticks: 8,
          rangeslider: {
            range: [],
            visible: false,
          },
          showgrid: false,
          showline: true,
          zeroline: true,
          linecolor: "#636363",
          anchor: "y",
          ticklen: 5,
        },
        yaxis: {
          autorange: true,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          tickformat: this.tickFormat,
          title: {
            text: this.yAxisTitle,
            standoff: 40,
          },
        },
        yaxis2: {
          autorange: true,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          overlaying: "y",
          side: "right",
          tickformat: this.tickFormatYaxis2,
        },
        showLegend: true,
        legend: {
          x: 0.35,
          y: -0.3,
          orientation: "h",
        },
        traceorder: "normal",
        font: {
          family: "sans-serif",
          size: 12,
          color: "#000",
        },
        bgcolor: "#2E2EE2",
        bordercolor: "silver",
        borderwidth: 2,
      };
    },
  },
};
</script>
